export enum REACTIONS_REACT {
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453772
     */
    USER_LIST_LIKES = 'USER_LIST_LIKES',
}
